export default [
  { value: 10, label: 'Показать 10' },
  { value: 15, label: 'Показать 15' },
  { value: 20, label: 'Показать 20' },
  { value: 30, label: 'Показать 30' },
  { value: 40, label: 'Показать 40' },
  { value: 50, label: 'Показать 50' },
];
